<template>
  <div class="my_donations">
    <div class="container">
      <div class="row">
        <div class="col-md-2">
          <sidebar />
        </div>
        <div class="col-md-10 my_donations__table--wraper">
          <div class="my_donations__table">
            <div class="my_donations__table--title mb-3">BAĞIŞ DETAY</div>
            <div class="my_donations__images">
              <div class="my_donations__images--img"
                v-for="(image,idx) in images"
                :key="idx"
                >
                <router-link :to="`/medya/${image.receipt_id}/${getToken(image.url)}`">
                  <i v-if="image.type === 'video'" class="fa fa-play icon"></i>
                  <img v-else :src="img(image.path)">
                </router-link>
              </div>
            </div>
            <vuetable
              v-show="!isLoading"
              class="table"
              :api-url="url"
              :data-path="''"
              :http-fetch="getData"
              @vuetable:loaded="onLoaded"
              @vuetable:loading="onLoading"
              @vuetable:load-success="onLoadSuccess"
              pagination-path
              :noDataTemplate="'Kayit bulunamadi'"
              :fields="columns"
            >
              <template slot="donation" scope="props">
                <span>{{ props.rowData.donation_product.name }}</span>
                <br />
                <span
                  v-if="props.rowData.qurban_groups.length
                    && !props.rowData.qurban_groups[0].delivered"
                 class="donation__info">Kesilecek</span>
                <span v-if="props.rowData.qurban_groups.length
                    && props.rowData.qurban_groups[0].delivered
                    && !props.rowData.qurban_groups[0].video
                    " class="donation__info--done">Kesildi</span>
                <router-link class="btn btn-success mt-2"
                  :to="`/kvideo/${props.rowData.qurban_groups[0].qurban_no}/${props.rowData.qurban_groups[0].video_token}`"
                  v-if="props.rowData.qurban_groups.length && props.rowData.qurban_groups[0].video">
                  Kurban Videosunu İzle <i class="ml-1 fas fa-video"></i>
                </router-link>
              </template>

              <template slot="donator" scope="props">
                <span>{{ props.rowData.donator_user.fullName }}</span>
                <br />
                <span class="donator__phone">{{ props.rowData.donator_user.phone_number }}</span>
              </template>

              <template slot="price" scope="props">
                <p>{{ parseFloat(props.rowData.price).toLocaleString() }} TL</p>
              </template>

              <template slot="total__price" scope="props">
                <p>{{(parseFloat(props.rowData.price) * props.rowData.quantity).toLocaleString()}} TL</p>
              </template>
            </vuetable>
            <Loader v-show="isLoading" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vuetable from 'vuetable-2'
import Sidebar from '@/components/Sidebar.vue'

export default {
  data() {
    return {
      isLoading: false,
      images: [],
      columns: [
        {
          name: '__slot:donation',
          title: 'Bağış'
        },
        {
          name: '__slot:donator',
          title: 'Bağışlayan'
        },
        {
          name: '__slot:price',
          title: 'Fiyat'
        },
        {
          name: 'quantity',
          title: 'Adet'
        },
        {
          name: '__slot:total__price',
          title: 'Toplam'
        }
      ]
    }
  },
  components: {
    Sidebar,
    Vuetable
  },
  methods: {
    getData(apiUrl, httpOptions) {
      return this.$http.get(apiUrl, httpOptions)
    },
    onLoading() {
      this.isLoading = true
    },
    onLoaded() {
      this.isLoading = false
    },
    onLoadSuccess(res) {
      res.data.forEach((item) => {
        item.media.forEach((image) => {
          image.receipt_id = item.id
          this.images.push(image)
        })
      })
    },
    getToken(str) {
      return str.substr(str.lastIndexOf('/') + 1, str.length)
    }
  },
  computed: {

  },
  created() {
    const { id } = this.$route.params
    this.url = `${this.$http.defaults.baseURL}v2/receipt-detail?receipt_id=${id}`
  }
}
</script>
